import {inject, injectable} from 'inversify';

import {CachedMediaFactory} from '../../../core/models/CachedMedia/CachedMedia.factory';
import {BaseVideoPlayerState} from './BaseVideoPlayerState';
import {VideoPlayerState} from './VideoPlayerState';

@injectable()
export class VideoPlayerStateFactory {
  constructor(
    @inject(CachedMediaFactory)
    private readonly cachedMediaFactory: CachedMediaFactory,
  ) {}

  create<T = VideoPlayerState>(props: BaseVideoPlayerState.Props): T {
    return new VideoPlayerState(props, this.cachedMediaFactory) as T;
  }
}
